import React, { useState } from "react";
import NavHeader from "../../Common/NavHeader";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { login } from "../api";

export default function LoginPage() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await login(formData);
    if (response.data.status === 200) {
      toast.success(response.data.message);
      setFormData({
        username: "",
        password: "",
      });
      window.location.href = '/';
    } else {
      toast.error(response.data.message);
      setFormData({
        username: "",
        password: "",
      });
    }
    setLoading(false);
  };
  return (
    <>
      <NavHeader view="Registration" />
      <ToastContainer />
      <Container fluid className="mt-5">
        <Row>
          <Col md={4} xs={12} className="bg-body-tertiary p-4">
            <Form
              onSubmit={handleSubmit}
              style={{
                marginTop: "40%",
              }}
            >
              <h2 className="text-center">Login Here</h2>
              <Form.Group controlId="formUsername">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your username or email"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="formPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Button
                variant="primary"
                disabled={loading}
                type="submit"
                className="my-4"
                style={{
                  width: "100%",
                }}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form>
            {/* <p className="my-1 text-center">Not a user <Link to="/register">Register Here</Link></p> */}
          </Col>

          {/* Right 60% - Image */}
          <Col md={8} className="d-none d-md-block p-0">
            <img
              src={`${process.env.PUBLIC_URL}/login.png`}
              alt="Registration"
              className="img-fluid w-100"
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}
